import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-delink',
  templateUrl: './delink.component.html',
  styleUrls: ['./delink.component.css']
})
export class DelinkComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
